import React, { Component } from 'react';
import classNames from 'classnames';
import styles from './FeedHeader.module.scss';
import { withTranslation, WithTranslation } from 'next-i18next';
import { NextRouter, withRouter } from 'next/router';
import ModalLink from 'next/link';
import Button from '@/components/core/Button/Button';
import { FEED_ACTION_TYPES } from '@/utils/constants';

interface WithRouterProps {
	router: NextRouter;
}

interface IFeedHeaderProps extends WithTranslation, WithRouterProps {
	className?: string;
	onCloseTo?: string;
	title?: string;
	subtitle?: string;
	visibleActionType?: string;
	language?: string;
}

class FeedHeader extends Component<IFeedHeaderProps> {
	constructor(props: IFeedHeaderProps) {
		super(props);
	}

	render() {
		const { onCloseTo, title, subtitle, visibleActionType, router, t } = this.props;
		const showContributeAction = visibleActionType === FEED_ACTION_TYPES.CONTRIBUTE;
		const showShareStoryAction = visibleActionType === FEED_ACTION_TYPES.SHARE_STORY;

		const headerClassNames = classNames(styles.header, this.props.className);

		return (
			<div className={headerClassNames}>
				<div className={styles.headerContentWrapper}>
					<div className={styles.headerContent}>
						<div className={styles.headerTitle}>{title}</div>
						<div className={styles.headerSubtitle}>{subtitle}</div>
						<div className={styles.headerActions}>
							<div className={styles.headerActionsItem}>
								{showContributeAction ? (
									<ModalLink href={{ query: { ...router.query, open: 'contribute' } }}>
										<Button hollow>{t('contribute-item')}</Button>
									</ModalLink>
								) : null}
								{showShareStoryAction ? (
									<ModalLink href={{ query: { ...router.query, open: 'share-story' } }}>
										<Button hollow>{t('pin--share-a-breakup')}</Button>
									</ModalLink>
								) : null}
							</div>
						</div>
						<div
							onClick={() =>
								router.push({ pathname: onCloseTo, query: { filter: router.query.filter || [] } }, undefined, {
									shallow: false,
								})
							}
							className={styles.headerClose}
						/>
					</div>
				</div>
			</div>
		);
	}
}

export default withTranslation()(withRouter(FeedHeader));
